import { VNode } from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";
import BaseView from "../core/BaseView";
import VideoUtil from "../utils/VideoUtil";

@Component
export default class XVideo extends BaseView {
  @Prop({ type: [String, Number], default: null })
  public readonly width?: string | number;

  @Prop({ type: [String, Number], default: null })
  public readonly height?: string | number;

  @Prop({ type: String, default: null })
  public readonly src?: string;

  @Prop({ type: String, default: null })
  public readonly posterUrl?: string;

  @Emit("bindref")
  public _bindref(ref: any): void {}

  private videoPlayer: VideoUtil | null = null;

  public mounted(): void {
    this.videoPlayer = VideoUtil.init(this.$refs.videoRef as HTMLVideoElement, {
      poster: this.posterUrl
    });
  }

  public pause(): void {
    this.videoPlayer?.pause();
  }

  public play(): void {
    this.videoPlayer?.play();
  }

  public destroyed(): void {
    this.videoPlayer?.dispose();
  }

  render(): VNode {
    return (
      <x-div width={this.width} height={this.height}>
        <video style={{
          width: "100%",
          height: "100%"
        }} ref="videoRef" class="video-js vjs-big-play-centered">
          <source id="source" src={this.src} type="video/mp4" />
        </video>
      </x-div>
    );
  }
}